//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BusinessProcessMessageText from './BusinessProcess/BusinessProcessMessageText.vue'

export default {
  name: 'WarningBanner',
  components: {
    BusinessProcessMessageText
  },
  props: {
    warning: {
      type: [Array, String],
      default: null
    },
    warningFormat: {
      type: String,
      default: null
    },
    iconColor: {
      type: String,
      default: null
    }
  },
  computed: {
    warningsLocal: function () {
      if (this.warning) {
        if (Array.isArray(this.warning)) {
          return this.warning
        } else if (typeof this.warning === 'string') {
          return [this.warning]
        }
      }
      return []
    }
  }
}
